// src/components/Logo.jsx
// Migrated verbatim from prototype/between-the-lines-v2.html lines 6469-6484.

import React from 'react';
import { IconFeather } from './icons.jsx';

export const Logo = ({ theme = 'gold', size = 'md' }) => {
    const textClass = theme === 'gold' ? 'text-book-accent' : theme === 'burgundy' ? 'text-burgundy-accent' : theme === 'midnight' ? 'text-midnight-accent' : theme === 'leather' ? 'text-leather-accent' : 'text-charcoal-accent';
    const sizes = { sm: { main: 'text-xs', sub: 'text-[10px]' }, md: { main: 'text-sm', sub: 'text-xs' }, lg: { main: 'text-base', sub: 'text-sm' } };
    const s = sizes[size];
    return (
        <div className="flex items-center gap-3">
            <div className={`w-9 h-9 border ${textClass.replace('text-', 'border-')} rounded-sm flex items-center justify-center`}>
                <IconFeather className={`w-5 h-5 ${textClass}`} />
            </div>
            <div className="text-center">
                <div className={`font-display ${textClass} ${s.main} leading-tight`}>Between the Lines</div>
                <div className={`text-book-muted ${s.sub} font-serif sig-tagline sig-tagline--logo leading-tight`}>with Danielle</div>
            </div>
        </div>
    );
};

export default Logo;
